<template>
  <global-dialog-card v-model="model" :title="$t('meal_size1')" hide-actions>
    <v-form ref="form" v-model="valid">
      <v-row align="center" class="mt-1">
        <v-col>
          <text-field
            v-model="new_size"
            :label="$t('add_meal_size')"
            :rules="[rules.required]"
          ></text-field>
        </v-col>
        <v-col cols="auto">
          <primary-button
            :dark="valid"
            :disabled="!valid || loading.saving"
            :loading="loading.saving"
            @click="saveSizes"
          >
            {{ $t("add") }}
          </primary-button>
        </v-col>
        <v-col cols="12">
          <v-subtitle>{{ $t("all_sizes") }}</v-subtitle>
          <template v-for="(size, index) in sizes">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ size.name }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ $t("align") }}: {{ size.poredak }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon>
                <table>
                    <tbody>
                      <tr>
                        <td>
                           <edit-button class="mr-2" @click="openDialogEditSize(size)"></edit-button>
                        </td>
                        <td>
                          <remove-button @click="removePortion(size)"></remove-button>
                        </td>
                      </tr>
                    </tbody>
                </table>
              </v-list-item-icon>
            </v-list-item>
            <v-divider v-if="index < sizes.length - 1"></v-divider>
          </template>
        </v-col>
      </v-row>
    </v-form>
    <food-portion-edit-dialog
      v-model="dialogEditSizes"
      :editSizes="editSizes"
      @editItemConfirm="$emit('editItemConfirm', $event)"
    >
    </food-portion-edit-dialog>
  </global-dialog-card>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import hasValidation from "@/mixins/hasValidation";
import hasSnackbar from "@/mixins/hasSnackbar";
import FoodPortionEditDialog from "./FoodPortionEditDialog.vue";
import foodService from "@/services/food";

export default {
  name: "FoodPortionDialog",
  mixins: [hasModel, hasValidation, hasSnackbar],
  props: {
    sizes: {
      type: Array,
      required: true,
    },
  },
  components: {
    FoodPortionEditDialog,
  },
  data() {
    return {
      new_size: "",
      dialogEditSizes: false,
      editSizes: {},
      loading: {
        saving: false,
        deleting: false,
      },
    };
  },
  methods: {
    saveSizes() {
      this.loading.saving = true;
      let data = {
        name: this.new_size,
        restaurant_id: this.$store.state.restaurant.id,
      };
      foodService
        .addNewSize(data)
        .then(({ data }) => {
          const newSizes = (data || []).filter(
            (item) => !this.sizes.some((size) => size.id === item.id)
          );
          this.new_size = ""; // Clear the input field after saving
          this.sizes.push(...newSizes);
          this.showSuccessSnackbar(this.$t("saved_successfully"));
        })
        .catch((error) => {
          console.error("Error saving size:", error);
          this.showErrorSnackbar(this.$t('error_saving_size'));
        })
        .finally(() => {
          this.loading.saving = false;
        });
    },

    openDialogEditSize(size) {
      this.dialogEditSizes = true;
      this.editSizes = size;
    },
    removePortion(size) {
      this.$refs.confirmBox
        .open(this.$t("delete_portion"), this.$t("delete_portion_confirmation"), {
          color: "error",
        })
        .then(() => {
          this.loading.deleting = true;
          foodService
            .deleteSize(size)
            .then(({ data }) => {
              if (data) {
                this.sizes = data;
              }
              this.showSuccessSnackbar(this.$t("deleted_successfully"));
            })
            .catch((error) => {
              console.error("Error deleting size:", error);
              this.showErrorSnackbar(this.$t('error_deleting_size'));
            })
            .finally(() => {
              this.loading.deleting = false;
            });
        })
        .catch((err) => console.warn(err));
    },
  },
};
</script>
